export default import.meta.ROLLUP_FILE_URL_Lc_MQjXiN4lmnki3Nq9Hww